export default "__VITE_ASSET__43112c57__"